import EventEmitter from 'events';

import Api from '../tools/api';
import util from '../tools/util';

import { SWAPS } from '../data/swap';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  getSwapContract,
  getFeeBps,
  getMarketList,
  getPriceList,
  sortTokens,
  fetchMarketList,
  fetchPriceList,
};

const DEFAULT_FEE_BPS = 10;

const g_marketListMap = new Map<string, any[]>();
const g_priceListMap = new Map<string, any>();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done && done();
}
function getSwapContract(chain_id: number): string {
  const swap = _getSwap(chain_id);
  return swap && swap.contract_addr;
}
function getFeeBps(chain_id: number): number {
  const swap = _getSwap(chain_id);
  return (swap && swap.fee_bps) || DEFAULT_FEE_BPS;
}
function getMarketList(coin) {
  const { chain_id, contract_addr } = coin;
  const key = chain_id + '_' + contract_addr;
  return g_marketListMap.get(key);
}
function getPriceList(params) {
  const { chain_id } = params.token;
  const { token_addr, currency_addr } = sortTokens(params);
  const key = chain_id + '_' + token_addr + '_' + currency_addr;
  return g_priceListMap.get(key);
}
function sortTokens(params) {
  const { token, currency } = params;
  const addr1 = token.contract_addr.toLowerCase();
  const addr2 = currency.contract_addr.toLowerCase();
  let ret;
  if (addr1.localeCompare(addr2) > 0) {
    ret = { token_addr: addr1, currency_addr: addr2 };
  } else {
    ret = { token_addr: addr2, currency_addr: addr1 };
  }
  return ret;
}
function fetchMarketList(coin) {
  const { chain_id, contract_addr } = coin;
  const key = chain_id + '_' + contract_addr;
  const swap_addr = getSwapContract(chain_id);
  const opts = {
    url: `/cached/1/harbour_swap/${chain_id}/${swap_addr}/token/${contract_addr}`.toLowerCase(),
  };
  Api.cdnGet(opts, (err, body) => {
    if (err === 404) {
      // noop
    } else if (err) {
      util.errorLog('SwapStore.fetchMarketList:', err, body);
    } else if (body && body.market_list) {
      g_marketListMap.set(key, body.market_list);
      _emit('market_list');
    }
  });
}
function fetchPriceList(params) {
  const { chain_id } = params.token;
  const { token_addr, currency_addr } = sortTokens(params);
  const key = chain_id + '_' + token_addr + '_' + currency_addr;
  const swap_addr = getSwapContract(chain_id);
  const opts = {
    url: `/cached/1/harbour_swap/${chain_id}/${swap_addr}/token/${token_addr}/currency/${currency_addr}`.toLowerCase(),
  };
  Api.cdnGet(opts, (err, body) => {
    if (err === 404) {
      // noop
    } else if (err) {
      util.errorLog('SwapStore.fetchPriceList:', err, body);
    } else if (body && body.price_list) {
      g_priceListMap.set(key, body.price_list);
      _emit('price_list');
    }
  });
}

function _getSwap(chain_id: number) {
  return SWAPS.find((swap) => swap.chain_id === chain_id);
}
